import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryListController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryListController.php
* @route '/api/invoicing-category'
*/
const GetInvoicingCategoryListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicingCategoryListController.url(options),
    method: 'get',
})

GetInvoicingCategoryListController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing-category',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryListController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryListController.php
* @route '/api/invoicing-category'
*/
GetInvoicingCategoryListController.url = (options?: RouteQueryOptions) => {
    return GetInvoicingCategoryListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryListController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryListController.php
* @route '/api/invoicing-category'
*/
GetInvoicingCategoryListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicingCategoryListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoicingCategory\GetInvoicingCategoryListController::__invoke
* @see app/Http/Controllers/InvoicingCategory/GetInvoicingCategoryListController.php
* @route '/api/invoicing-category'
*/
GetInvoicingCategoryListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoicingCategoryListController.url(options),
    method: 'head',
})

export default GetInvoicingCategoryListController